exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pricingTable-sign-up-go .btn-block.btn-default.buy-now-box-btn {\n    background: #31730e;\n    width: 177px;\n    color: #fff;\n    padding: 5px;\n    float: right;\n    cursor: pointer;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/packageinvoice/packageinvoice.component.css
// module id = ../../../../../src/app/home/packageinvoice/packageinvoice.component.css
// module chunks = common